// src/components/common/Popup.jsx
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import './Popup.css';

function Popup({ isOpen, onClose, title, children, size = 'md', showClose = true, closeOnOverlay = true }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!isOpen) return;
    document.body.style.overflow = 'hidden';
    const handleEsc = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div className="popup-overlay" onClick={closeOnOverlay ? onClose : undefined}>
      <div
        className={`popup popup--${size}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        {showClose && (
          <button className="popup__close" onClick={onClose} aria-label={t('popup.closeAria')}>
            ✕
          </button>
        )}
        {title && <h2 className="popup__title">{title}</h2>}
        <div className="popup__content">{children}</div>
      </div>
    </div>,
    document.body
  );
}

export default Popup;